import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { MultiSelect } from 'react-multi-select-component';
import StationDetails from './StationDetails';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Trash from "../../../assets/images/delete.svg";
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faLink } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken, } from '../../../Services/axios.js';
import { ULDSETTINGSTATION, STATIONS, ADDSTATION, STATIONGRID, ADDTRUCKSCHEDULE, ARCSTATIONGRID, ACTSTATIONGRID, REMSTATIONGRID } from '../../../Utils/conts.js';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { toast } from 'react-toastify';

export const StationSettings = ({ onGridDataUpdate }) => {

  const isMounted = useRef(false);
  const [selected, setSelected] = useState([]);

  const handleChange = (selected) => {
    setSelected(selected);
  };

  // +++++++++++++++++++++++++++++++ Multiselect dropdown

  const gridRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);

  const fetchDataGrid = async () => {
    try {
      const res = await withRFSToken.post(ULDSETTINGSTATION, {})
        .then(function (res) {
          const innerData = res.data.Rows;
          setGridData(innerData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    setIsLoading(true);
    setGridData({});
    isMounted.current = true;
  }, []);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const [gridSelect, setGridSelect] = useState([]);

  const [formData, setFormData] = useState({
    port_Id: '',
    code: ''
  });

  // const handleRowClick = (rowData) => {
  //   setSelectedRowData(rowData);
  // };
  const handleDetailsBackClick = (rowData) => {
    // setSelectedRowData(rowData);
    setShowDetails(false);
    setIsLoading(true);
    setGridData({});
  };

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {

    if (gridRef.current && !showDetails) {

      // if (gridData) {
      //   const localData = gridData.map((item, index) => ({
      //     id: item.station_id,
      //     STN: item.station_code,
      //     Taddrs: item.address_count, // item.station_addresses.length
      //     // Address: item.station_addresses // ?.join(', ')Join the address array into a string
      //   }));
      // console.log("🚀 ~ localData ~ localData:", localData)
      // var token = "Bearer " + localStorage.ULD;
      const originalOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url, ...args) {
        originalOpen.call(this, method, url, ...args);
        // if (url.includes(process.env.REACT_APP_RFS_URL)) {
        this.withCredentials = true;
        // }
      };
      const source = {
        datatype: 'json',
        id: '1',
        datafields: [
          { name: 'station_id', type: 'string' },
          { name: 'station_code', type: 'string' },
          { name: 'Taddrs', type: 'string' },
          { name: 'address_count', type: 'string' },
          { name: 'handlers', type: 'string' },
        ],
        url: `${process.env.REACT_APP_RFS_URL}${ULDSETTINGSTATION}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 20,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
        { text: 'Stations', filtertype: 'input', datafield: 'station_code', width: '40%', cellclassname: 'frcl', },
        { text: 'Total Address', filtertype: 'input', datafield: 'address_count', width: '50%', cellclassname: 'frcl', },
      ];

      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        // selectionmode: 'checkbox',
        pageable: true,
        pageSize: 10,
        pagesizeoptions: ['20', '50', '100', '200'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
      };

      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).on('rowclick', (event) => {

        const args = event.args.row.bounddata;
        // console.log('args', args);
        const sendRowId = gridData;
        // console.log('args', args);
        // console.log("🚀 ~ window.$ ~ sendRowId:", sendRowId)
        setSelectedRowData(args)

        setShowDetails(true);
      });
      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      // row selection by checkbox
      window.$(gridRef.current).on('rowselect', (event) => {
        // console.log("🚀 ~ window.$ ~ event:00000000", event.args.row)

        if (event.args.row) {

          const selectedRow = event.args.row.id;

          if (!gridSelect.includes(selectedRow)) {
            setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
          }
          setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
        } else {
          // Handle "Select All" case
          // const allIds = planData.map(row => row.booking_id);
          // console.log("All IDs:", allIds);
          // setGridSelect(allIds);
          console.log("Select All triggered");
        }
      });
      // console.log('ggg', gridSelect);
      window.$(gridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.id;
          setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
        } else {
          setGridSelect([]);
        }
      });
      // End row selection 

    }
  }, [gridData]);
  // row click function start

  const handleDetails = (dta) => {
    console.log('dta', dta);
    setSelectedRowData(dta)
    // setShowDetails(true);
  }

  // const reloadGrid = async () => {
  //   try {
  //     const res = await withRFSToken.post(STATIONGRID, {})
  //     .then(function(res) {
  //       const innerData = res.data.response_data; 
  //       setGridData(innerData);
  //     });

  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* <div className="">
        <Header logo_url={SBack ? SBack : '/ULDControl'} sBackUrl={SBack ? SBack : '/ULDControl'}  />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="row">
              <LeftSettings /> */}
      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          {!showDetails &&
            <>
              <h4>Station Settings</h4>
              <p>Set your notification preferences for when you are in or away from the dashboard.</p>
              <div className='row'>
                <div className='col-6'>
                  <div className="station_grid">
                    {isLoading && <div ref={gridRef} className='staion_grid' ></div>}
                  </div>
                </div>
              </div>
            </>
          }
          {showDetails && (
            <>
              <button className='backbtn' onClick={handleDetailsBackClick}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
              <StationDetails rowData={selectedRowData} reload={fetchDataGrid} />
            </>
          )}
        </div>
      </div>
      {/* </div>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default StationSettings;